import { render, staticRenderFns } from "./UpdateAccountStatusWarning.vue?vue&type=template&id=1e70b25d"
import script from "./UpdateAccountStatusWarning.vue?vue&type=script&lang=js"
export * from "./UpdateAccountStatusWarning.vue?vue&type=script&lang=js"
import style0 from "./UpdateAccountStatusWarning.vue?vue&type=style&index=0&id=1e70b25d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports